import { render, staticRenderFns } from "./AvContractJobContentForm.vue?vue&type=template&id=ba8730b6&"
import script from "./AvContractJobContentForm.vue?vue&type=script&lang=js&"
export * from "./AvContractJobContentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AvContractJobContentForm.vue"
export default component.exports